import Immutable from 'immutable';

import {
  QUESTIONNAIRE360_LOADING_START,
  QUESTIONNAIRE360_LOADING_SUCCESS
} from '../actions/questionnaire360.js';

const initialState = Immutable.fromJS({
  data: [],
  loadingState: 'IDLE'
});

export default function(state = initialState, action) {
  switch (action.type) {
    case QUESTIONNAIRE360_LOADING_START:
      return state.set('loadingState', 'PENDING');

    case QUESTIONNAIRE360_LOADING_SUCCESS:
      return state
        .set('data', Immutable.fromJS(action.data))
        .set('loadingState', 'SUCCESS');

    default:
      return state;
  }
}

// ===  SELECTORS  ==
export const getLoadingState = state =>
  state && state.getIn(['questionnaire360', 'loadingState']);

export const getTests360 = state =>
  (state && state.getIn(['questionnaire360', 'data'])) || Immutable.Map();
